define('modules/editor/social_manager',['require','exports','module'],function(require, exports, module){
	"use strict";

  module.exports = {
    facebook: {
      scriptId: "facebook-jssdk",
      reloadCode: "<script>window.FB && window.FB.XFBML.parse()</script>",
      scriptTag: "<script>(function(d, s, id) {" +
                 " var js, fjs = d.getElementsByTagName(s)[0];" +
                 " if (d.getElementById(id)) return;" +
                 " js = d.createElement(s); js.id = id;" +
                 " js.src = \"//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.0\";" +
                 " fjs.parentNode.insertBefore(js, fjs);" +
                 " }(document, 'script', 'facebook-jssdk'));</script>"
    },
    twitter: {
      scriptId: "twitter-wjs",
      scriptTag: "<script>!function(d,s,id) {" +
                 " var js,fjs=d.getElementsByTagName(s)[0]," +
                 " p=/^http:/.test(d.location)?'http':'https';" +
                 " if(!d.getElementById(id)){" + 
                 "  js=d.createElement(s);js.id=id;" + 
                 "  js.src=p+'://platform.twitter.com/widgets.js';" + 
                 "  fjs.parentNode.insertBefore(js,fjs);}" + 
                 "}(document, 'script', 'twitter-wjs');</script>"
    },
    google: {
      scriptTag: "<script class=\"js-script-google\"  src=\"https://apis.google.com/js/platform.js\" async defer>" +
                 " {lang: 'es'} </script>"
    }
  };
});

